import type { ReactNode } from "react";

interface SelectionCardProps {
    isSelected: boolean;
    isDisabled?: boolean;
    onClick: () => void;
    "aria-label"?: string;
    "data-testid"?: string;
    children: ReactNode;
}

/** The option card of the selection steps, styled like the creation flow's source options. */
const SelectionCard = (props: SelectionCardProps) => (
    <button
        type="button"
        onClick={props.onClick}
        disabled={props.isDisabled}
        aria-pressed={props.isSelected}
        aria-label={props["aria-label"]}
        className={`flex min-h-[var(--size-selection-card-min-height)] items-center gap-s rounded-small-container border-2 border-solid p-s text-left transition-[border-color] ${
            props.isSelected
                ? "border-creation-primary bg-creation-primary-light-pastel"
                : "border-p6-grey-lightest bg-white"
        } ${props.isDisabled ? "cursor-default opacity-60" : "cursor-pointer hover:border-creation-primary"}`}
        data-testid={props["data-testid"]}
    >
        {props.children}
    </button>
);

export default SelectionCard;
